module.exports = __webpack_public_path__ + "assets/img/wxin1.994a028a.png";